import { TextInput } from '@mantine/core';
import { CommonInputProps } from './DataInputField';

export function DataInputText({
  inputValue,
  setInputValue,
  onSave,
  onKeyDown,
  variant,
  autoFocus,
  ariaLabelledBy,
}: CommonInputProps) {
  return (
    <TextInput
      value={String(inputValue || '')}
      onChange={e => setInputValue(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={onSave}
      variant={variant}
      autoFocus={autoFocus}
      styles={{ input: { maxWidth: '100%' } }}
      aria-labelledby={ariaLabelledBy}
    />
  );
}
